<template>
  <button class="flex h-8 w-8 items-center justify-center" @click="handleClick">
    <IconClose v-if="isMenuOpen" class="h-6 w-6 text-gray-600" />
    <IconMenu v-else class="h-6 w-6 text-blue-400" />
  </button>
</template>

<script setup lang="ts">
  import { EnumCNMenuIndex, EnumMenuIndex } from '@/stores/menuStore';

  const { isTablet } = useScreen();
  const { isCN } = useLanguage();
  const menuStore = useMenuStore();
  const { currentMenu, isMenuOpen } = storeToRefs(menuStore);

  const handleClick = (): void => {
    isMenuOpen.value = !isMenuOpen.value;

    if (currentMenu.value === null && isMenuOpen.value && isTablet.value) {
      // TODO: 待 CN 選單確定改版後移除
      if (isCN.value) {
        currentMenu.value = EnumCNMenuIndex.SOLUTIONS;
      } else {
        currentMenu.value = EnumMenuIndex.PRODUCTS;
      }
    }
  };
</script>
